export default "__VITE_ASSET__D2YHyw8Z__"